import Vue from 'vue'
import CDatePicker from '@/view/components/CDatePicker.vue'
import CDateTimePicker from '@/view/components/CDateTimePicker.vue'
import CAcademicYear from '@/view/components/CAcademicYear.vue'
import CTenant from '@/view/components/CTenant.vue'
import CFormType from '@/view/components/CFormType.vue'
import CLesson from '@/view/components/CLesson.vue'
import CExamResultLessonGroup from "@/view/components/CExamResultLessonGroup.vue";
import CExamKind from "@/view/components/CExamKind.vue";
import CApp from "@/view/components/CApp.vue";
import CLessonBranch from "@/view/components/CLessonBranch.vue";

Vue.component('c-date-picker', CDatePicker)
Vue.component('c-datetime-picker', CDateTimePicker)
Vue.component('c-academic-year', CAcademicYear)
Vue.component('c-tenant', CTenant)
Vue.component('c-form-type', CFormType)
Vue.component('c-lesson', CLesson)
Vue.component('c-exam-result-lesson-group', CExamResultLessonGroup)
Vue.component('c-exam-kind', CExamKind)
Vue.component('c-app', CApp)
Vue.component('c-lesson-branch', CLessonBranch)
